<template>
  <div class="pl-5 pr-5">
    <p style="text-align: center; font-weight: 600; font-size: 18px;" class="mb-0 pt-4">{{ text }}</p>
    <p style="text-align: center;">{{$t('PINtoConfirm')}}</p>

    <div style="text-align: center;">
      <input v-model="pinNumber" type="password" :placeholder="$t('Pin')">
    </div>
    <div class="error" v-if="error != ''" style="margin-left: 10px;">{{ error }}</div>
    <div class="row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4">
      <div class="col flex-grow pr-2">
        <Button :title="$t('Cancel')" buttonClass='cancel-button semi-bold w-100' @onClick="cancel" />
      </div>
      <div class="col flex-grow pl-2">
        <Button :title="$t('Confirm')" buttonClass='save-button semi-bold w-100' @onClick="confirm" />
      </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/Button'
import { deleteInvitations } from '@/api/api'

export default {
  props: ['text', 'invitationId'],
  watch: {},
  methods: {
    async confirm() {
      if (this.pinNumber == null || this.pinNumber.length == 0) {
        this.error = 'Required';
      } else {
        this.error = '';
        await deleteInvitations(this.invitationId, this.pinNumber)
          .then((d) => {
            this.$emit("confirm");
          }).catch((error) => {
            if (error.response.data != undefined) {
              this.error = error.response.data.error
            } else {
              // console.log({ err: error.response })
              this.error = ""
            }
          })
      }
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  computed: {},
  components: {
    Button
  },
  mounted: function () { },
  data: function () {
    return {
      pinNumber: '',
      error: ''
    }
  }
}
</script>
<style scoped>
.error {
  text-align: left !important;
  color: #FD8282;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/PinModal.vue